module.exports = __webpack_public_path__ + "img/15.42c5715b.jpg";